import React from 'react';

import type { IBonusBanner } from '~/src/features/yandex-landing/BonusBanner/types';
import PriceBlock from '~/src/features/yandex-landing/PriceBlock';

import * as ST from './styled';

const BonusBanner: React.FC<IBonusBanner> = ({ stationLight, city }) => {
    return (
        <ST.BonusWrapper>
            <ST.BannerTitle>
                Что вы получаете:
            </ST.BannerTitle>
            <PriceBlock city={city} stationLight={stationLight}/>
        </ST.BonusWrapper>
    );
};

export default BonusBanner;
